export default __webpack_public_path__ + "static/media/mushroom.3ec02852.png";